import { Component, inject, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { GlobalPageHeaderComponent } from '../../../../../../../../components/global-page-header/global-page-header.component';
import { NlToBrPipe } from '../../../../../../../../pipes/nl-to-br.pipe';

@Component({
  selector: 'app-p0003605-en-savoir-plus-dosage',
  templateUrl: './p0003605-en-savoir-plus-dosage.component.html',
  styleUrls: ['./p0003605-en-savoir-plus-dosage.component.scss'],
  standalone: true,
  imports: [
    TranslatePipe,
    IonContent,
    GlobalPageHeaderComponent,
    IonButton,
    NlToBrPipe,
  ],
})
export class P0003605EnSavoirPlusDosageComponent {
  private modalController: ModalController = inject(ModalController);

  constructor() {}

  async dismissModal() {
    await this.modalController.dismiss();
  }
}
